// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"RecommendedProductsBox_tableWrapper__1O-bg"};